module.exports = __webpack_public_path__ + "img/energias_cura.da92c028.jpeg";